export const CLOSE_EVENT = "close";
export const EVENT_OPEN_DIALOG = "openDialog";
export const EVENT_SUCCESS = "success";
export const SUBMIT_EVENT = "submit";
